var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('v-row',{staticClass:"mt-7",attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","lg":"10","md":"10","sm":"12","xs":"12"}},[_c('TrackTable')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }